<template>
  <a-float-button-group
    :class="[
      bem.b(),
      trigger !== 'hover' && trigger !== 'click' ? 'no-trigger' : '',
    ]"
    v-bind="attrs"
    :trigger="trigger"
  >
    <template
      v-for="item in Object.keys($slots).filter((key) => key !== 'icon')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template v-if="menus?.length > 0">
      <template v-for="(item, index) in menus" :key="index">
        <ll-float-button
          v-if="item.componentType === 'floatButton'"
          v-bind="item"
          @click="handleClick(item, index)"
        />
        <ll-back-top
          v-else-if="item.componentType === 'backTop'"
          v-bind="item"
          @click="handleClick(item, index)"
        />
      </template>
    </template>

    <template v-if="icon.iconName || $slots.icon" #icon>
      <slot name="icon">
        <ll-icon v-bind="icon" />
      </slot>
    </template>
  </a-float-button-group>
</template>
<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import { floatButtonGroupProps } from './float-button'

// 1.defineOptions
defineOptions({ name: 'LlFloatButtonGroup' })

const attrs = useAttrs()

const bem = createNamespace('float-button-group')

defineProps(floatButtonGroupProps)

const emits = defineEmits(['click'])

const handleClick = (item, index) => {
  emits('click', item, index)
}
</script>
